import 'nodelist-foreach-polyfill';
import svg4everybody from 'svg4everybody';
import 'inputmask';
import 'jquery-validation';

svg4everybody();